export default {
  // 广告平台类型（用于i18n）
  'adsPlatform.80004001': '谷歌',
  'adsPlatform.80004002': '脸书',
  'adsPlatform.80004003': '推特',
  'adsPlatform.80004004': '抖音',
  'adsPlatform.80004005': 'Adjust',
  'adsPlatform.80004006': 'SGTM',
  // 归因事件类型（用于i18n）
  'adsEvent.80005001': '注册',
  'adsEvent.80005002': '首充',
  'adsEvent.80005003': '复充',
  // 上传状态类型（用于i18n）
  'adsPushStatus.80006001': '上传中',
  'adsPushStatus.80006002': '上传失败',
  'adsPushStatus.80006003': '上传成功',
  // 页面标题
  'adsAccount.title': '广告列表',

  // 搜索字段
  'adsAccount.platform': '归因平台',
  'adsAccount.name': '归因名称',

  // 按钮
  'adsAccount.search': '查询',
  'adsAccount.reset': '重置',
  'adsAccount.add': '新增',
  'adsAccount.edit': '编辑',
  'adsAccount.delete': '删除',
  'adsAccount.save': '保存',
  'adsAccount.cancel': '取消',

  // 表格列
  'adsAccount.serial': '序号',
  'adsAccount.adsId': '平台账户ID',
  'adsAccount.conversionId': '转化ID',
  'adsAccount.gtmId': 'GTM-ID',
  'adsAccount.mccAccount': '关联MCC账户',
  'adsAccount.accessToken': '访问令牌',
  'adsAccount.clientId': 'OAuth Client ID',
  'adsAccount.registerEventPath': '注册事件标识',
  'adsAccount.firstRechargeEventPath': '首充事件标识',
  'adsAccount.rechargeEventPath': '复充事件路径',
  'adsAccount.registerConversionLabel': '注册转化标签（GTM）',
  'adsAccount.firstRechargeConversionLabel': '首冲转化标签（GTM）',
  'adsAccount.repeatRechargeConversionLabel': '复充转化标签（GTM）',
  'adsAccount.status': '状态',
  'adsAccount.otherParams': '归因参数',
  'adsAccount.action': '操作',

  // 状态
  'adsAccount.active': '启用',
  'adsAccount.inactive': '禁用',

  // 表单验证
  'adsAccount.platformRequired': '请选择归因平台',
  'adsAccount.nameRequired': '请输入归因名称',
  'adsAccount.adsIdRequired': '请输入平台账户ID',
  'adsAccount.conversionIdRequired': '请输入转化ID',
  'adsAccount.mccAccountRequired': '请选择关联MCC账户',
  'adsAccount.mccAccountPlaceholder': '请输入关联MCC账户',
  'adsAccount.accessTokenRequired': '请输入访问令牌',
  'adsAccount.clientIdRequired': '请输入OAuth Client ID',
  'adsAccount.registerEventPathRequired': '请输入注册事件标识',
  'adsAccount.firstRechargeEventPathRequired': '请输入首充事件标识',
  'adsAccount.repeatRechargeEventPathRequired': '请输入复充事件路径',

  // 表单占位符
  'adsAccount.namePlaceholder': '请输入归因名称',
  'adsAccount.adsIdPlaceholder': '请输入平台账户ID',
  'adsAccount.conversionIdPlaceholder': '请输入转化ID',
  'adsAccount.registerEventPathPlaceholder': '例如：/register/123',
  'adsAccount.firstRechargeEventPathPlaceholder': '例如：/recharge/123',
  'adsAccount.registerConversionLabelPlaceholder': '例如：5txfCOaKzuwbEOPCia9A',
  'adsAccount.firstRechargeConversionLabelPlaceholder': '例如：5txfCOaKzuwbEOPCia9A',
  'adsAccount.repeatRechargeConversionLabelPlaceholder': '例如：5txfCOaKzuwbEOPCia9A',

  // 弹窗标题
  'adsAccount.addAdsAccount': '新增广告归因配置',
  'adsAccount.editAdsAccount': '编辑广告归因配置',

  // 消息提示
  'adsAccount.addSuccess': '新增成功',
  'adsAccount.addFailed': '新增失败',
  'adsAccount.editSuccess': '编辑成功',
  'adsAccount.editFailed': '编辑失败',
  'adsAccount.deleteSuccess': '删除成功',
  'adsAccount.deleteFailed': '删除失败',
  'adsAccount.confirmDelete': '确认删除此条记录吗？',
  'adsAccount.validationError': '请填写所有必填字段',
  'adsAccount.fetchDataFailed': '获取数据失败',
  'adsAccount.fetchTypesFailed': '获取归因平台类型失败',
  'adsAccount.fetchMccAccountsFailed': '获取MCC账户列表失败',
  'adsAccount.noData': '暂无数据',

  // 分页
  'adsAccount.totalRecords': '共 {total} 条记录',
  'adsAccount.pagination': '第 {current} 页，共 {page} 页，总计 {total} 条记录',
};
